import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { Layout } from "@/components/layout/Layout";
import { Navbar } from "@/components/layout/Navbar";
import AuthCallback from "@/pages/AuthCallback";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import About from "@/pages/About";
import Careers from "@/pages/Careers";
import Academy from "@/pages/Academy";
import Book from "@/pages/Book";
import Testimonials from "@/pages/Testimonials";
import Contact from "@/pages/Contact";
import GetStarted from "@/pages/GetStarted";
import Login from "@/pages/Login";
import Portal from "@/pages/Portal";
import Admin from "@/pages/Admin";
import PaymentResult from "@/pages/PaymentResult";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<Home />} />
        <Route path="/services" element={<Services />} />
        <Route path="/about" element={<About />} />
        <Route path="/careers" element={<Careers />} />
        <Route path="/academy" element={<Academy />} />
        <Route path="/book" element={<Book />} />
        <Route path="/testimonials" element={<Testimonials />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/get-started" element={<GetStarted />} />
        <Route path="/login" element={<Login />} />
        <Route path="/portal" element={<Portal />} />
        <Route path="/payment/success" element={<PaymentResult />} />
        <Route path="/payment/cancel" element={<PaymentResult />} />
      </Route>
      <Route path="/admin" element={<><Navbar /><Admin /></>} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <Toaster theme="dark" position="top-right" toastOptions={{ style: { background: "#14051C", border: "1px solid rgba(212,175,55,.35)", color: "#fff" } }} />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
